export default __webpack_public_path__ + "static/media/napoje_zimne.c3272dbd.svg";